/* =====================================================================
   Superette × Fish Wishlist v2 — "Buy it again" = consumables only (v1.0)
   ⚠ JavaScript. Never paste into the Fish Wishlist Custom CSS box.
   Fish fills Buy it again with everything the customer has bought. Only products whose
   product type mentions Beauty or Grooming (e.g. "Womens - Beauty - Skincare",
   "Mens - Grooming", "Unisex - Beauty and Grooming") stay; the rest are hidden, the count
   follows, and the whole list hides when nothing qualifies.
   Product type comes from templates/product.sp-wishlist.liquid ("type").
   ===================================================================== */
(() => {
  const CONSUMABLE = /beauty|grooming/i;
  const cache = new Map();
  const typeOf = (handle) => {
    if (!cache.has(handle)) {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      cache.set(handle, fetch(`${root}products/${encodeURIComponent(handle)}?view=sp-wishlist`, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => (d && typeof d.type === 'string' ? d.type : null))
        .catch(() => null));
    }
    return cache.get(handle);
  };
  const handleOf = (a) => {
    try { const m = new URL(a.getAttribute('href'), location.origin).pathname.match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null; } catch (e) { return null; }
  };
  const filterCard = async (card) => {
    const rows = [...card.querySelectorAll('fw2-item-row')];
    if (!rows.length) return;
    const keep = await Promise.all(rows.map(async (row) => {
      const a = row.querySelector('.fw2-row__title, a[href*="/products/"]');
      const h = a && handleOf(a);
      if (!h) return true;
      const type = await typeOf(h);
      return type == null ? true : CONSUMABLE.test(type); // unknown type → leave it to Fish
    }));
    if (!card.isConnected) return;
    const hidden = new Set();
    rows.forEach((row, i) => {
      row.classList.toggle('sp-ba-hide', !keep[i]);
      if (!keep[i]) hidden.add(String(row.dataset.id));
    });
    card.querySelectorAll('.fw2-thumb img[data-id]').forEach((img) => {
      const t = img.closest('.fw2-thumb');
      if (t) t.classList.toggle('sp-ba-hide', hidden.has(String(img.dataset.id)));
    });
    const visible = rows.length - hidden.size;
    const count = card.querySelector('.fw2-card__count');
    const label = `${visible} ${visible === 1 ? 'item' : 'items'}`;
    if (count && count.textContent.trim().toLowerCase() !== label) count.textContent = label;
    const slot = card.closest('[class*="fw2-buy-again-slot"]') || card;
    slot.classList.toggle('sp-ba-hide', visible === 0);
  };
  const run = () => document.querySelectorAll('[class*="fw2-buy-again-slot"] fw2-list-card').forEach(filterCard);
  let queued = false;
  const schedule = () => { if (queued) return; queued = true; setTimeout(() => { queued = false; run(); }, 60); };
  const init = () => {
    run();
    new MutationObserver((muts) => {
      // ignore our own class/count edits
      if (muts.every((m) => m.target.closest && m.target.closest('.fw2-card__count'))) return;
      schedule();
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
